//#region libraries
import { useEffect, useState } from 'react';

// custom components
import { Card, CustomCard, CustomSpinner } from '_atoms';

// bootstrap
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';

import { DateTime } from "_atoms";
import { selectDateToISO, setDate } from '_redux/slices/prm-bookings/calendar';

// redux
import { selectIata } from '_redux/slices/main-screen/user';
import { getAnalyticsCountInboundByHour, getAnalyticsCountOutboundByHour, getAnalyticsStats, selectAnalyticsStats, selectAnalyticsTypeSelector, selectDeparturesArrivalsCountByFlight, selectMaxPage, setTypeSelector } from '_redux/slices/prm-bookings/bookings-count';
import { useDispatch, useSelector, } from 'react-redux';

import * as BookingService from '_services/booking-service';

import { selectUserDb } from '_redux/slices/main-screen/user';

import { add } from 'date-fns';
// utils
import { lookupIsLoading } from '_utils/statusUtil';

// tremor librarues
import { BarChart, ColGrid, Subtitle, Text, Title, Toggle, ToggleItem, Col as TremorCol } from '@tremor/react';
// icons
import { selectAirlineSelectedAirport } from '_redux/slices/prm-bookings/bookings';
import { selectBookingTableType } from '_redux/slices/prm-bookings/bookings-table';
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
//#endregion

//#region components
const dataFormatter = (number) => {
    return Intl.NumberFormat("us").format(number).toString();
};
//#endregion

//#endregion

const BookingsByFlight = (props) => {
    //#region local state
    const [airlineReportCode, setAirlineReportCode] = useState('')
    const [page, setPage] = useState(0)
    //#endregion

    //#region redux 
    const dispatch = useDispatch();
    const analyticsDate = useSelector(selectDateToISO)          // start date of the week
    const analyticsTypeSelector = useSelector(selectAnalyticsTypeSelector)          // 'source' (app/sita/portal) or 'none' (all bookings)
    const type = useSelector(selectBookingTableType);
    const data = useSelector(selectDeparturesArrivalsCountByFlight(type, page));
    const maxPage = useSelector(selectMaxPage(type, page));
    const analyticsStats = useSelector(selectAnalyticsStats)
    const userDb = useSelector(selectUserDb);
    const iata = useSelector(selectIata);
    const airport = useSelector(selectAirlineSelectedAirport)

    // const statusObj = useSelector(countSlice.selectStatusObj) // Object with keys being service function names
    const isLoading = useSelector(state => lookupIsLoading(state.count.statusObj, ["getAnalyticsStats", "getAnalyticsCountOutboundByHour", "getAnalyticsCountInboundByHour"]))
    //#endregion



    //#region useEffect
    useEffect(() => {

        setPage(0)

        let countParams = {
            iata: userDb.details.type == 'AIRLINE' ? airport : iata,
            date: analyticsDate,
            endDate: add(new Date(analyticsDate), { days: 0 }).toISOString().split('T')[0],
            source: analyticsTypeSelector,
            airline: userDb.details.type == 'AIRLINE' ? userDb.details.authority : null,
            byFlight: true
        }

        dispatch(getAnalyticsCountInboundByHour(countParams))
        dispatch(getAnalyticsCountOutboundByHour(countParams))
        dispatch(getAnalyticsStats(countParams))

    }, [analyticsTypeSelector, analyticsDate, airport]);

    useEffect(() => {
        setPage(0)
    }, [type])

    //#endregion  

    return (
        <>
            <ColGrid>

                {/* Date Picker */}
                <Row className='mt-2'>
                    <Col xs={9}>
                        <Toggle color="zinc" defaultValue={analyticsTypeSelector} onValueChange={(value) => dispatch(setTypeSelector(value))}>
                            <ToggleItem value={'none'} text="All Bookings" />
                            <ToggleItem value={'P'} text="Portal" />
                            <ToggleItem value={'A'} text="App" />
                            <ToggleItem value={'S'} text="SITA" />
                        </Toggle>
                    </Col>
                    <Col>
                        <DateTime date={analyticsDate} setDate={(date) => { dispatch(setDate(date)) }} />
                    </Col>
                </Row>

                {isLoading ? (
                    <CustomSpinner rowCenter={true} />
                ) : (
                    <>
                        {
                            /* Statistic Tabs */
                            analyticsStats &&
                            <ColGrid numColsMd={1} numColsLg={4} gapX="gap-x-6" gapY="gap-y-6" marginTop="mt-6">
                                <CustomCard noBadge={true} title={'Departures'} data={analyticsStats.outbound} text={`${analyticsStats.outboundDiff ? analyticsStats.outboundDiff.toFixed(1) : 0}%`} />
                                <CustomCard noBadge={true} title={'Arrivals'} data={analyticsStats.inbound} text={`${analyticsStats.inboundDiff ? analyticsStats.inboundDiff.toFixed(1) : 0}%`} />
                                <CustomCard noBadge={true} title={'Total'} data={analyticsStats.total} text={`${analyticsStats.totalDiff ? analyticsStats.totalDiff.toFixed(1) : 0}%`} />
                            </ColGrid>
                        }
                        {
                            <ColGrid numColsMd={1} numColsLg={6} gapX="gap-x-6" gapY="gap-y-6" marginTop="mt-6">

                                {maxPage != 0 && page != 0 && <BsChevronLeft onClick={() => { setPage(page - 1) }} size={20} style={{ cursor: 'pointer' }} color='#307FE2' />}
                                {maxPage != 0 && <Text>{page + 1} / {maxPage + 1}</Text>}
                                {maxPage != 0 && page < maxPage && <BsChevronRight onClick={() => { setPage(page + 1) }} size={20} style={{ marginLeft: 12, cursor: 'pointer' }} color='#307FE2' />}
                                {/* Graph */}
                                <TremorCol numColSpanLg={6}>
                                    {data && data.length > 0 ?
                                        <Card>
                                            <Row>
                                                <Col><Title>Booking Graph</Title><Subtitle>View the number of bookings pre flight</Subtitle></Col>
                                            </Row>
                                            <Row>
                                                {
                                                    <BarChart
                                                        data={data}
                                                        dataKey="name"
                                                        categories={["Number of bookings (Departure)", "Number of bookings (Arrival)"]}
                                                        colors={['blue', 'green']}
                                                        marginTop="mt-5"
                                                        yAxisWidth="w-12"
                                                        valueFormatter={dataFormatter}
                                                    />
                                                }
                                            </Row>
                                        </Card>
                                        :
                                        <Row>
                                            <Col><Title>No bookings found</Title></Col>
                                        </Row>
                                    }

                                </TremorCol>
                            </ColGrid>
                        }

                        <Row className='mt-5'>
                            <Col xs={8}>

                                <Card>
                                    {/* Title */}
                                    <Title>Flight Report</Title><Subtitle>Get a report of PRM passengers on a given flight</Subtitle>

                                    {/* Search Form & Button */}
                                    <Form.Group>
                                        <Row>
                                            <Row className='mt-3'>
                                                <Col>
                                                    <Form.Label>Flight Number</Form.Label>
                                                    <Form.Control onChange={(e) => { setAirlineReportCode(e.target.value.toUpperCase()) }} type="name" placeholder="Input Flight number" defaultValue={airlineReportCode} value={airlineReportCode} />
                                                </Col>
                                                <Col className='mt-4'>
                                                    <Button variant='outline-primary' onClick={async () => {
                                                        try {
                                                            let stream = await BookingService.getExcelReport({ "iata": iata, "carrierCode": airlineReportCode.slice(0, 2), "flightNumber": airlineReportCode.slice(2,), "flightDate": analyticsDate })
                                                            let excel_file = await new Response(stream).blob()
                                                            const element = document.createElement("a");
                                                            element.href = URL.createObjectURL(excel_file);
                                                            element.download = `prm_flight_report_${airlineReportCode}_${analyticsDate}.xlsx`;
                                                            document.body.appendChild(element);
                                                            element.click();
                                                            setAirlineReportCode("")
                                                        } catch (e) {
                                                            console.log("error", e)
                                                            alert("Error generating report")
                                                        }
                                                    }}>{'Download report for a flight'}</Button>
                                                </Col>

                                                <Row className='mt-3'></Row>
                                                <Col className='mt-4'>
                                                    <Button variant='outline-primary' onClick={async () => {
                                                        try {
                                                            let stream = await BookingService.getExcelReport({ "iata": iata, "flightDate": analyticsDate })
                                                            let excel_file = await new Response(stream).blob()
                                                            const element = document.createElement("a");
                                                            element.href = URL.createObjectURL(excel_file);
                                                            element.download = `prm_flights_report_${analyticsDate}.xlsx`;
                                                            document.body.appendChild(element);
                                                            element.click();
                                                        } catch (e) {
                                                            console.log("error", e)
                                                            alert("Error generating report")
                                                        }
                                                    }}>{'Download report for all flights'}</Button>
                                                </Col>
                                            </Row>
                                        </Row>
                                    </Form.Group>
                                    {/* Search Form & Button */}

                                    {/* Flight List 
                                        <FlightList />*/}
                                </Card>
                            </Col>
                        </Row>
                    </>
                )}
            </ColGrid>

        </>
    );
}
export default BookingsByFlight;